module.exports = __webpack_public_path__ + "img/hr-reactor-connect-patches.45868820.png";